module.exports = __webpack_public_path__ + "img/login_bg.ba495736.png";